module.exports = __webpack_public_path__ + "static/media/logo-white.876c86d1.png";